if (!process.env.REACT_APP_API_URL)
  throw new Error(
    `You need to provide REACT_APP_API_URL environment variable`
  )
export const ApiUrl = process.env.REACT_APP_API_URL
if (!process.env.REACT_APP_STORAGE_URL)
  throw new Error(
    `You need to provide REACT_APP_STORAGE_URL environment variable`
  )
export const StorageUrl = process.env.REACT_APP_STORAGE_URL
